export default __webpack_public_path__ + "static/media/megan.3b50d782.gif";